module.exports = __webpack_public_path__ + "img/sms.b4bb47d5.svg";